import { render, staticRenderFns } from "./UserDetails_Header_Small.vue?vue&type=template&id=4c463aa0&scoped=true&"
import script from "./UserDetails_Header_Small.vue?vue&type=script&lang=js&"
export * from "./UserDetails_Header_Small.vue?vue&type=script&lang=js&"
import style0 from "./UserDetails_Header_Small.vue?vue&type=style&index=0&id=4c463aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c463aa0",
  null
  
)

export default component.exports